import { render, staticRenderFns } from "./blur-queue-table.vue?vue&type=template&id=621fbf52"
import script from "./blur-queue-table.vue?vue&type=script&lang=js"
export * from "./blur-queue-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports